export default "__VITE_ASSET__BfNPpOwp__"